import type { BaseBridgeOptions, MessageBase } from './BaseBridge';
import { BaseBridge } from './BaseBridge';

export interface IOSBridgeOptions extends BaseBridgeOptions {}

export class IOSBridge extends BaseBridge {
  static get iosBridge() {
    return window.webkit?.messageHandlers?.iOS_Halo_Native_Bridge;
  }

  constructor(options?: IOSBridgeOptions) {
    if (!IOSBridge.iosBridge) {
      throw new Error('iOS not found');
    }

    super(options);
    this.initIOSBridge();
  }
  private postMessage(msg: any) {
    IOSBridge.iosBridge.postMessage(msg);
  }
  private initIOSBridge() {
    Object.assign(window, {
      haloBridge: {
        response: async (res: string) => {
          const data = JSON.parse(res);

          const { type } = data as MessageBase;

          switch (type) {
            case 'request': {
              const response = await this.handleRequest(data);
              this.postMessage(response);
              break;
            }
            case 'response':
              this.responseHandler(data);
              break;
            case 'notification':
              this.handleNotification(data);
              break;
          }
        },
      },
    });
  }

  request(method: string, params: Record<string, any> | undefined) {
    return this.requestHandler(method, params, this.postMessage);
  }

  notify(method: string, payload?: Record<string, any> | undefined) {
    this.postMessage({ type: 'notification', method, payload });
  }
  // TODO amo: dispose
  [Symbol.dispose]() {}
}
